import * as React from 'react';
import { Escape } from '@cian/ui-kit/services/Escape';
import { IconClose16 } from '@cian/ui-kit';
import { PropsWithChildren } from 'react';

import * as styles from './styles.css';

interface IModalDesktop extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
}
export const VideoPlaybackModalDesktop: React.FC<IModalDesktop> = ({ isOpen, onClose, children }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isOpen) {
      ref.current?.focus();
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [isOpen]);

  return (
    <Escape active onEscape={onClose}>
      <div role="dialog" ref={ref} className={styles['modal-container']} data-testid="video-playback-modal">
        <button className={styles['close-button']} aria-label="Закрыть" onClick={onClose}>
          <IconClose16 color="white_100" />
        </button>
        <div className={styles['background']} onClick={onClose} aria-hidden="true" />
        {children}
      </div>
    </Escape>
  );
};
